import { PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface RingDevicesAssignedTableFilterValues {
  fieldDeviceId: string;
}

export interface RingDevicesAssignedTableFilterProps
  extends PropsWithChildren<any> {
  deploymentRingId: string;
}

export const RingDevicesAssignedTableFilter = ({
  children,
  deploymentRingId
}: RingDevicesAssignedTableFilterProps) => {
  const filterItems: Item<RingDevicesAssignedTableFilterValues>[] = [
    {
      name: "fieldDeviceId",
      type: "searchBox",
      stickItem: true,
      props: {
        placeholder: "Search by FieldDeviceId",
        removeSpecialCharacters: false
      }
    }
  ];

  return (
    <FilterBar<RingDevicesAssignedTableFilterValues>
      items={filterItems}
      key={deploymentRingId} // This key allows re-render of table when deploymentRingId changes
      initialValues={{
        fieldDeviceId: ""
      }}
    >
      {children}
    </FilterBar>
  );
};
